import api from '@/api'
import Coms from '@/communications'
import bus from '@/plugins/bus'
import isEmpty from 'lodash/isEmpty'
import delay from 'lodash/delay'
import isNil from 'lodash/isNil'
import axios from 'axios'

export default {
  async uploadPreviewImage ({ commit, state }, { file, notify }) {
    const willNotify = isNil(notify) ? true : notify

    try {
      const token = await Coms.project.getProjectPreviewUploadToken(state.id)

      const formData = new FormData()
      formData.append('image', file)

      const response = await api.post('/api/v1/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Token': token,
          'Socket-Id': Coms.util.getSocketId()
        }
      })

      if (isEmpty(response.data.photo)) {
        const error = 'No image path was returned from the server.'
        console.error(error)
        if (willNotify) {
          bus.emit('notification', error, {
            color: 'error',
            dark: true
          })
        }
        throw new Error(error)
      }

      // Check if resource exists
      let tries = 0

      const checkForAsset = async () => {
        try {
          await axios.head(response.data.photo)
          commit('setPreviewImage', response.data.photo)
          if (willNotify) {
            bus.emit('notification', 'The preview image was updated successfully.', {
              color: 'success',
              dark: true
            })
          }
          return response.data.photo
        } catch (err) {
          if (tries < 10) {
            tries++
            delay(checkForAsset, 1000)
          } else {
            const error = 'The image was uploaded, but the path obtained seems to be invalid.'
            console.error(err, error)
            if (willNotify) {
              bus.emit('notification', error, {
                color: 'error',
                dark: true
              })
            }
            throw new Error(error)
          }
        }
      }

      return await checkForAsset()
    } catch (error) {
      const message = error?.response?.data || error?.message || 'Upload failed.'
      console.error(error)

      if (willNotify) {
        bus.emit('notification', message, {
          color: 'error',
          dark: true
        })
      }

      throw error
    }
  },

  async deletePreviewImage ({ commit, state }) {
    try {
      const data = await Coms.project.deletePreviewImage(state.id)

      commit('setPreviewImage', null)
      bus.emit('notification', 'The preview image was deleted.', {
        color: 'success',
        dark: true
      })

      return data
    } catch (err) {
      console.error(err)
      bus.emit('notification', err, {
        color: 'error',
        dark: true
      })
      throw err
    }
  }
}
